import React, { useState } from 'react'
import mainRoutes from '../../component/routes/routes'
import { Button, Container, Row, Col, Card, ListGroup, Badge } from 'react-bootstrap';
import { ClientService } from '../../component/services/client.service';
import toast from 'react-hot-toast';


export default function PagesIndex() {
    const [loading, setLoading] = useState(false);

    const pages = mainRoutes.map((route, index) => {
        return (
            <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                <div>
                    <strong>{route.name}</strong>
                </div>
                <div>
                    <strong>{route.path}</strong>
                </div>
            </ListGroup.Item>
        )
    });

    async function syncPages() {
        setLoading(true);
        const pages = mainRoutes.map((route) => {
            return {
                name: route.name,
                path: route.path
            }
        });
        await ClientService.syncPages({ pages })
            .then((res) => {
                toast.success("Pages synced successfully");
            })
            .catch((err) => {
                console.error("Sync failed", err);
                toast.error("Failed to sync pages: " + (err.response?.data || "Unknown error"));
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Container className="py-4">
            <Row>
                <Col md={8} className="mx-auto">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h4 className="mb-1">Application Routes</h4>
                        </div>
                        <Badge bg="secondary">{mainRoutes.length} routes</Badge>
                    </div>

                    <Card className="mb-4">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Route List</h6>
                            <Button
                                variant="primary"
                                onClick={syncPages}
                                disabled={loading}
                                size="sm"
                            >
                                {loading ? 'Syncing...' : 'Sync Pages'}
                            </Button>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <ListGroup variant="flush">
                                {pages}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
};